import EditIcon from '@mui/icons-material/EditRounded';
import CloseIcon from '@mui/icons-material/Close';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownwardRounded';
import { LabeledDivider, DividerIconButton } from '@components/LabeledDivider';
import { useTranslation } from '@hooks';
import { getLocalizedValue } from '../helpers';

const SectionDivider = ({ section, isFirst, isLast, isView, defaultLanguage, onEdit, onDelete, onMove }) => {
    const { t } = useTranslation();

    const name = getLocalizedValue(section.names, defaultLanguage);
    const itemsCount = (section.items || []).length;

    return (
        <LabeledDivider
            label={`${name || t('MenusPage.untitledSection')} · ${itemsCount} ${t('MenusPage.itemsCount')}`}
            labelColor={name && itemsCount > 0 ? 'var(--text-secondary)' : 'var(--error-main)'}
        >
            {!isView ? (
                <>
                    <DividerIconButton onClick={onEdit} size="small">
                        <EditIcon />
                    </DividerIconButton>
                    {!isFirst ? (
                        <DividerIconButton onClick={() => onMove(-1)} size="small">
                            <ArrowUpwardIcon />
                        </DividerIconButton>
                    ) : null}
                    {!isLast ? (
                        <DividerIconButton onClick={() => onMove(1)} size="small">
                            <ArrowDownwardIcon />
                        </DividerIconButton>
                    ) : null}
                    {!isFirst ? (
                        <DividerIconButton onClick={onDelete} size="small">
                            <CloseIcon />
                        </DividerIconButton>
                    ) : null}
                </>
            ) : null}
        </LabeledDivider>
    );
};

export default SectionDivider;
